export default "__VITE_ASSET__DjbKX4YS__"